import { Config } from "../../configurations/config";
export const MyProfile_API = {
  //------------------------ My Profile -----------------------//

  GetMyProfile: `${Config.server_url}${Config.api_prefix}/Employee/MyProfile`,
  PutMyProfile: `${Config.server_url}${Config.api_prefix}/Employee/MyProfile`,
};
